import { TopRankIcon } from '@terminal/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';
import clsx from 'clsx';
import type { KeyboardEvent, ReactNode } from 'react';

import { LoadingCell } from '../loading-cell/LoadingCell';
import styles from './RowItem.module.scss';

export type KnowledgeGraphRowType =
  | 'brand'
  | 'theme'
  | 'competitor'
  | 'country';

export interface RowItemProps {
  rowType: KnowledgeGraphRowType;
  rank?: number;
  onClick?: () => void;
  isLoading?: boolean;
  className?: string;
  contentClassName?: string;
  children?: ReactNode;
}

export const RowItem = ({
  rowType,
  rank,
  onClick,
  isLoading = false,
  className,
  contentClassName,
  children,
}: RowItemProps) => {
  const dataAttribute = { [`data-${rowType}-row`]: true };

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={clsx(styles.row, isLoading && styles.loadingRow, className)}
      {...dataAttribute}
      onClick={isLoading ? undefined : onClick}
      onKeyDown={isLoading ? undefined : handleKeyDown}
      role="button"
      tabIndex={onClick && !isLoading ? 0 : undefined}
    >
      {isLoading ? (
        <LoadingCell />
      ) : (
        <>
          <div className={clsx(styles.contentWrapper, contentClassName)}>
            {children}
          </div>
          {rank !== undefined && <TopRankIcon rank={rank} iconSize={28} />}
        </>
      )}
    </div>
  );
};
